<div class="gwc-payment-profiles">
	@if (!isLoading()) {
		@if (paymentProfiles().length > 0 && mode() === 'profiles') {
			@for (profile of paymentProfiles(); track profile.uuid) {
				<div class="gwc-card gwc-payment-profiles-card gwc-payment-profiles__item"
					role="radio"
					tabindex="0"
					[attr.aria-checked]="selectedProfile() === profile.uuid"
					[class.gwc-payment-profiles__item--selected]="selectedProfile() === profile.uuid"
					(click)="selectProfile(profile.uuid)"
					(keydown.enter)="selectProfile(profile.uuid)"
					(keydown.space)="selectProfile(profile.uuid); $event.preventDefault()">
					<div>
						<img [src]="`assets/payment/${profile.brand.toLowerCase()}.svg`" />
						<div class="gwc-payment-profiles__info">
							<div class="gwc-payment-profiles__info-label">
								Owner
							</div>
							<div>{{ profile.name }}</div>
						</div>
	
						<section class="gwc-payment-profiles__card-info">
							<div class="gwc-payment-profiles__info">
								<div class="gwc-payment-profiles__info-label">
									Last 4
								</div>
								<div>
									<span class="gwc-payment-profiles__info-last4">**** ****</span> **** {{ profile.last4 }}
								</div>
							</div>
							<div class="gwc-payment-profiles__info">
								<div class="gwc-payment-profiles__info-label">
									Expiration Date
								</div>
								<div>{{ profile.exp_month }}/{{ profile.exp_year.substring(2, 4) }}</div>
							</div>
						</section>

					</div>
					</div>
			}
			<button mat-stroked-button 
				color="primary"
				class="gwc-button gwc-button--rounded gwc-button--outline gwc-payment-profiles__add-card" 
				(click)="addNewCard()">
				Add New Card
			</button>
		} @else {
			<div class="gwc-card gwc-payment-profiles-card">
				<gwc-credit-card-form [ccForm]="ccForm"></gwc-credit-card-form>
				<section class="gwc-payment-profiles__actions">
					<!-- <button mat-flat-button 
						color="primary"
						class="gwc-button gwc-button--rounded" 
						(click)="addNewCard()">
						Save Card
					</button> -->
					@if (paymentProfiles().length > 0) {
						<button mat-stroked-button 
							color="primary"
							class="gwc-button gwc-button--rounded gwc-button--outline" 
							(click)="cancelNewCard()">
							Cancel
						</button>
					}
				</section>
			</div>
		}
	} @else {
		<div class="gwc-payment-profiles__loader">
			<mat-spinner diameter="64"></mat-spinner>
		</div>
	}
</div>
